import { ridSegment } from '@krp/client-runtime'

/**
 * Служебные ручки Resource.OneC по одной базе (`diagnostics.read`, решение
 * владельца 07.10 п. 1): профиль без секретов и проверка связи — одно чтение
 * `$metadata` в 1С (GET).
 */
const base = (resourceId: string) => `/api/onec/v1/resources/${ridSegment(resourceId)}`

export const ONEC_CONNECTION_URLS = {
  profile: (resourceId: string) => `${base(resourceId)}/profile`,
  check: (resourceId: string) => `${base(resourceId)}/connection/check`,
  /** Состояние доставки уведомлений 1С по базе (право catalog.refresh): читает только нашу службу, в 1С не ходит. */
  webhookDelivery: (resourceId: string) => `${base(resourceId)}/webhook-delivery`,
  /** Смена секрета вебхука: новый показывается один раз, прежние отзываются. */
  webhookRotate: (resourceId: string) => `${base(resourceId)}/webhook-sources/rotate`,
  /** «Повторить» пакеты, требующие внимания: из очереди внимания брокера обратно в основную (право catalog.refresh). */
  webhookAttentionRetry: (resourceId: string) => `${base(resourceId)}/webhook-attention/retry`,
} as const
